// extracted by mini-css-extract-plugin
export default {"pageContainer":"MainLayout_pageContainer__airgv","contentContainer":"MainLayout_contentContainer__YKxzi","formContainer":"MainLayout_formContainer__yDYZT"};